import axios from "axios";

const api = axios.create({
  baseURL: "/api",
  timeout: 10000,
});

// 요청마다 Authorization 헤더 자동 주입
api.interceptors.request.use((config) => {
  if (typeof window !== "undefined") {
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

// 401 → 토큰 제거
api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401 && typeof window !== "undefined") {
      localStorage.removeItem("access_token");
    }
    return Promise.reject(error);
  }
);

export default api;
